export default __webpack_public_path__ + "static/media/icon-pending.bd6a753a.svg";